import i18n from 'i18next';

export const columns = [
  {
    id: 'code',
    numeric: false,
    disablePadding: true,
    label: i18n.t('dca.code'),
    needSorting: true,
  },
  {
    id: 'description',
    numeric: false,
    disablePadding: true,
    label: i18n.t('dca.description'),
    needSorting: false,
  },
  {
    id: 'fromDate',
    numeric: false,
    disablePadding: true,
    label: i18n.t('dca.startTime'),
    needSorting: true,
  },
  {
    id: 'toDate',
    numeric: false,
    disablePadding: true,
    label: i18n.t('dca.endTime'),
    needSorting: true,
  },
];
